export const stats = {
  visible: false,
  noteMoyenne: 0,
  utilisateurs: 0,
  courriersAnalyses: 0,
  courriersAujourdhui: 0
};
